import React from "react"
import { THGResult } from "@hg/hg-web-sdk/dist/core/account/HG"
import { RoleProvider } from "@hg/one-account"
import { HG_SDK } from "@hg/one-account/lib/types"

import { useFetchRole } from "@/hooks/useFetchRole"
import { useLogin } from "@/hooks/useLogin"
import EventBus from "@/utils/eventBus"
import { adapter, sdkReady } from "@/utils/sdk"

export interface CustomLoginModalProps {
    smsCountDown: number
    sendSMS: (phone: string) => Promise<THGResult<null>>
    loginByPassword: (
        username: string,
        password: string
    ) => ReturnType<HG_SDK["User"]["loginByPassword"]>
    loginByCode: (
        username: string,
        smsCode: string
    ) => ReturnType<HG_SDK["User"]["loginByCode"]>
    fetchRoleInfo:any
}

const Layout: React.FC<{
    context: {
        type: string
        dispatch: React.Dispatch<any>
    }
    children: React.ReactNode
}> = ({ children, context }) => {
    const { returnButton } = adapter.ui

    const { type, dispatch } = context

    // 登陆
    const handleSelectRole = useLogin(type)

    // 获取用户信息
    const handleFetchRoleInfo = useFetchRole(dispatch)

    return (
        <RoleProvider
            gameCode="ak"
            sdkReady={sdkReady}
            customChannelSelect
            accountProviderProps={{
                customLoginDialog: true,
            }}
            onSelectRole={handleSelectRole}
            fetchRoleInfo={handleFetchRoleInfo}
            onNoRole={(res) => {
                dispatch({
                    type: "updateContext",
                    payload: { hasRole: false },
                })

                !res.auto &&
                    EventBus.publish("showRoleSelect", {
                        message: "Hello from EventBus!",
                    })
            }}
            onError={(err) => {
                console.error(err)
            }}
            channels={
                returnButton
                    ? undefined
                    : [
                          {
                              channel: "bilibili",
                              option: {
                                  clientId: __BILIBILI_CLIENT_ID,
                              },
                          },
                      ]
            }
        >
            {children}
        </RoleProvider>
    )
}
export default Layout
